// Example LOINC codes for lab tests
// Source: https://loinc.org/ (subset for demo)
const loincCodes = [
  { code: "718-7", description: "Hemoglobin [Mass/volume] in Blood" },
  { code: "4548-4", description: "Hematocrit [Volume Fraction] of Blood" },
  { code: "2951-2", description: "Sodium [Moles/volume] in Serum or Plasma" },
  { code: "2823-3", description: "Potassium [Moles/volume] in Serum or Plasma" },
  { code: "2339-0", description: "Glucose [Mass/volume] in Blood" },
  { code: "6299-2", description: "Cholesterol in LDL [Mass/volume] in Serum or Plasma" },
  { code: "2093-3", description: "Cholesterol [Mass/volume] in Serum or Plasma" },
  { code: "2571-8", description: "Creatinine [Mass/volume] in Serum or Plasma" },
  { code: "2160-0", description: "Creatinine [Moles/volume] in Serum or Plasma" },
  { code: "6690-2", description: "Leukocytes [#/volume] in Blood by Automated count" }
];

export function searchLoincCodes(query) {
  if (!query || query.length < 2) return [];
  
  const searchTerm = query.trim().toLowerCase();
  return loincCodes.filter(item =>
    item.code.toLowerCase().includes(searchTerm) ||
    item.description.toLowerCase().includes(searchTerm)
  );
}

export default loincCodes;
